import React, { useState } from "react";
import {
  previewWarning,
} from "../features/theme/icons";
const Warning = ({subtitle}) => {
  const [show, hide] = useState(true);
  const promoClick = () => {
    window.location.href = "/study/NCT04611802";
  };
  // const onHide = () => {
  //   hide(false);
  // };

  const Preview = () => {
    return (
      <div className="preview_mode py-3 align-items-center justify-content-center row">
        <img
          className="warning_icon mx-3 img-fluid"
          src={previewWarning}
          alt="warning"
        ></img>
        <div className="col-lg-10 preview_content mx-3 text-center">
          <div className="d-flex align-items-center justify-content-between">
            <h5>This trial is not actively recruiting.</h5>
            {/* <img
              onClick={() => onHide()}
              className="warning_close_icon"
              src={warningCloseIcon}
              alt="close"
            ></img> */}
          </div>
          <p
            style={{ cursor: "pointer" }}
            onClick={() => promoClick()}
            className="mb-0 text-left"
          >
            {subtitle}
          </p>
        </div>
      </div>
    );
  };

  return (
    <div>
      {show ? (
        <Preview />
      ) : // <div className="warning d-flex align-items-center justify-content-between px-5">
      //   <div className="row ml-2 mt-2 d-flex align-items-center">
      //     <h2 className="col-sm-3 col-xs-6 col-md-3 col-lg-3">Beta Release!</h2>
      //     <h3 className="col-sm-8 col-xs-8 col-md-8 col-lg-8">
      //       "Please DO NOT submit your personal information. Please send feedback to hello@patientrials.com. Thank you!"
      //     </h3>
      //   </div>
      //   <img
      //     onClick={() => onHide()}
      //     src={close_icon}
      //     alt="warning_close_icon"
      //   ></img>
      // </div>
      null}
    </div>
  );
};

export default Warning;
